import React from "react";

const PasswordResetLink = ({
  id,
  isPasswordResetLinkOpen,
  closePasswordResetLink,
  customer,
}) => {
  return (
    <>
      <div
        id={id}
        className={`${
          isPasswordResetLinkOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[42%] mx-auto">
            <div className="mb-10 mx-auto items-center justify-center">
              <div className="flex items-center justify-between">
                <button
                  onClick={closePasswordResetLink}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm ml-auto inline-flex items-center "
                  data-modal-toggle={id}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="w-full flex flex-col items-center mt-5">
                <svg
                  width="53"
                  height="53"
                  viewBox="0 0 53 53"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="53" height="53" rx="26.5" fill="#BFDFFD" />
                  <path
                    d="M11 32L20.7544 38.7761L39.43 17.9347"
                    stroke="#074073"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>

                <p className="items-center text-center font-[600] text-[16px] mt-5">
                  Password Reset Link Sent
                </p>
                <p className="items-center text-center font-[400] text-[16px] mt-3">
                  A password reset link has been sent to
                </p>
                <p className="items-center text-center font-[400] text-[16px]">
                  {customer?.email}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordResetLink;
